/**
 * All system-level tags used in our codebase.
 *
 * Start collecting them all here for greater awareness about what tags we're
 * leaning on. Especially since `tags` is really a user-level property, and
 * we're beginning to take it over on the system side. */
export enum SystemTag {
  DuplicatedFrom = "duplicated-from",
  CohortCountry = "cohort-country",
  CohortCourseId = "cohort-course-id",
  CohortCourseLabel = "cohort-course-label",
  CohortCourseTitle = "cohort-course-title",
  CohortState = "cohort-state",
  CohortStateDistrict = "cohort-state-district",
  CohortStateRegion = "cohort-state-region",
  ExamResourceLinkDescription = "exam-resource-link-description",
  ExamResourceLinkId = "exam-resource-link-id",
  ExamResourceLinkTitle = "exam-resource-link-title",
  ExternalUserId = "external-user-id",
  InheritedFrom = "inherited-from",
  LtiContextId = "lti-context-id",
  ManagedByWorkspaceId = "managed-by-workspace-id",
  NoCopy = "system:no-copy",
  OriginExamId = "origin-exam-id",
  ProviderName = "provider-name",
  ProviderUserId = "provider-user-id",
  StudentAssignmentAccessCode = "student-assignment-access-code",
  StudentClassroomCourseId = "student-classroom-course-id",
  StudentClassroomId = "student-classroom-id",
  StudentGoogleClassroomStudentId = "student-google-classroom-student-id",
  StudentId = "student-id",
  StudentSisRosterStudentId = "student-sis-roster-student-id",
  UseCaseInsensitiveStudentIds = "use-case-insensitive-student-ids",
}
